/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import { normalizeString } from '@plone/volto/helpers/Utils/Utils';
import { renderLinkElement } from '@plone/volto-slate/editor/render';
import Slugger from 'github-slugger';

const messages = defineMessages({
  view_all: { id: 'Vedi tutto', defaultMessage: 'Vedi tutto' },
});

interface VariationWrapperProps {
  variation: string;
  show_block_bg: boolean;
  image_bg: Array<any>;
  color_title: string;
  items: [];
  title: string;
  children: object;
  linkTitle: string;
  linkHref: [{ '@id': string }];
}

const Headline = ({
  headlineTag,
  id,
  data = {},
  className,
  listingItems,
  isEditMode,
}: Record<string, any>) => {
  let attr = { id };
  const slug = Slugger.slug(normalizeString(data.headline));
  attr.id = slug || id;
  const LinkedHeadline = useMemo(
    () => renderLinkElement(headlineTag),
    [headlineTag],
  );
  return (
    <LinkedHeadline
      mode={!isEditMode && 'view'}
      children={data.headline}
      attributes={attr}
      className={cx('headline', className, {
        emptyListing: !listingItems?.length > 0,
      })}
    />
  );
};

const VariationWrapper: React.FC<VariationWrapperProps> = (data) => {
  const intl = useIntl();

  const {
    variation,
    show_block_bg,
    image_bg,
    color_title,
    items,
    id,
    headlineTag,
    headline,
    children,
    linkTitle,
    linkHref,
    isEditMode,
    background_color = 'primary',
    cta_color = 'white',
  } = data;

  const linkMore = linkHref?.[0]?.['@id'];

  // Background image
  const imageBgSize = 'leadimage';
  const imageObj = image_bg?.[0];
  const image = imageObj
    ? imageObj.image?.scales?.[imageBgSize]?.download ||
      imageObj['@id'] + '/@@images/image/' + imageBgSize
    : null;
  const imageUrl = image ? flattenToAppURL(image) : null;
  const HeadlineTag = headlineTag || 'h2';
  const content = (
    <Container className="variation-content">
      {headline && (
        <Headline
          headlineTag={HeadlineTag}
          id={id}
          listingItems={items}
          data={data}
          isEditMode={isEditMode}
          className={cx('block-title', {
            'title-black': color_title === 'black',
            'title-white': color_title === 'white',
          })}
        />
      )}

      <div className="listing-items-wrapper">{children}</div>

      {linkMore && (
        <div className={`link-more`}>
          <UniversalLink
            href={flattenToAppURL(linkMore)}
            className={`ui button ${cta_color}`}
          >
            {linkTitle || intl.formatMessage(messages.view_all)}
          </UniversalLink>
        </div>
      )}
    </Container>
  );
  return items?.length > 0 ? (
    <div className={`listing-template ${variation}`}>
      {show_block_bg ? (
        <>
          {imageUrl ? (
            <div
              className={`full-width block-bg bg-image bg-${background_color}`}
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            >
              {content}
            </div>
          ) : (
            <div className={`full-width block-bg bg-${background_color}`}>
              {content}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="no-bg full-width">{content}</div>
        </>
      )}
    </div>
  ) : null;
};

export default VariationWrapper;
